import * as Raven from "raven-js";
import * as React from "react";
import { IConfig } from "../IConfig";
import { IBaseModel } from "./IBaseModel";
const config: IConfig = require("Config");

type BaseProps = {
    model: IBaseModel
};
class BaseComponent< T extends BaseProps , S> extends React.Component<T, S> {
    componentDidCatch(error: Error, reactError: React.ErrorInfo) {
        if (!config.isDebug) {
            Raven.captureException(error);
        }
    }

    componentDidMount() {
        setTimeout(
            () => {
                this.props.model.prepare();
        },  1000);
    }
}
export default BaseComponent;


// WEBPACK FOOTER //
// ./src/utility/BaseComponent.ts